import { cast, Instance } from 'mobx-state-tree'
import { QuestionChoice } from '../models/QuestionChoice'
import { QuestionType } from '../models/QuestionType'

export const getChoicesByQuestionType = (type) => {
  let choices: Array<Instance<typeof QuestionChoice>> = []

  if (type === 'Multiple Choice' || type === 'Multiple Response') {
    choices = [
      QuestionChoice.create({
        text: null,
        correct: true,
      }),
      QuestionChoice.create({
        text: null,
        correct: false,
      }),
      QuestionChoice.create({
        text: null,
        correct: false,
      }),
    ]
  } else if (type === 'True or False') {
    choices = [
      QuestionChoice.create({
        text: 'True',
        correct: true,
      }),
      QuestionChoice.create({
        text: 'False',
        correct: false,
      }),
    ]
  } else if (type === 'Ordering') {
    choices = [
      QuestionChoice.create({
        text: null,
        correct: true,
        ordering: [{ text: '' }, { text: '' }, { text: '' }],
      }),
    ]
  } else if (type === 'Matching') {
    choices = [
      QuestionChoice.create({
        choice_id: null,
        text: null,
        errors: [],
        warnings: [],
        errorsCorrected: [],
        acceptedWarnings: [],
        factoid: null,
        pairs: [
          { left: '', right: '' },
          { left: '', right: '' },
          { left: '', right: '' },
        ],
        correct: true,
        order: null,
      }),
    ]
  } else if (type === 'Open Text') {
    choices = [
      QuestionChoice.create({
        choice_id: null,
        text: null,
        errors: [],
        warnings: [],
        errorsCorrected: [],
        acceptedWarnings: [],
        factoid: null,
        correct: true,
        order: null,
      }),
    ]
  }

  return choices
}
